module.exports = __webpack_public_path__ + "img/feedback.1cddee56.jpg";